export default __webpack_public_path__ + "static/media/ambient-bright-blue-green.7a34986d.jpg";